export default class UserError extends Error {
    constructor(message, ...params) {
        super(...params)

        if (Error.captureStackTrace) Error.captureStackTrace(this, UserError)
        this.name = 'UserError'
        this.content = message
        this.data = new Date()
    }
}